import { render, staticRenderFns } from "./sidebar-left.vue?vue&type=template&id=60606b32&scoped=true&"
import script from "./sidebar-left.vue?vue&type=script&lang=js&"
export * from "./sidebar-left.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-left.vue?vue&type=style&index=0&id=60606b32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60606b32",
  null
  
)

export default component.exports